import { Tag, Text } from '@mercai/clever'

import { SectionHeaderProps } from './section-header.type'

import { useTranslation } from 'react-i18next'
import styles from './section-header.module.css'

export const SectionHeader = ({
  title,
  children,
  isComplete,
}: SectionHeaderProps) => {
  const { t } = useTranslation('screenBusinessV2')

  return (
    <div className={styles.core}>
      {typeof title === 'function' ? (
        title
      ) : (
        <div className={styles['section-header-title']}>
          <Text variant="title-medium">{title}</Text>
          {isComplete !== undefined ? (
            !isComplete ? (
              <Tag variant="warning" model="light">
                {t('sectionIncompleteLabel')}
              </Tag>
            ) : (
              <Tag variant="success" model="light">
                {t('sectionCompleteLabel')}
              </Tag>
            )
          ) : (
            <></>
          )}
        </div>
      )}
      {children}
    </div>
  )
}
